import React, {useState} from "react";
import { Box } from "@mui/material";
import quickLink from "../../../assets/home/sidebar/QuickLink.png";
import AddIcon from "../../../assets/home/sidebar/addIcon.png";
import GoogleIcon from "../../../assets/home/sidebar/googleIcon.png";
import JiraIcon from "../../../assets/home/sidebar/jiraIcon.png";
import Modal from "./modal"
import "../home.scss";

const QuickLinks = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  return (
    <>
      <Box
        className="slidebar-container  br-16"
        marginTop="20px"
        paddingY="15px"
      >
        <Box
          className="balance-container d-flex"
          gap="20px"
          paddingBottom="10px"
          alignItems="center"
        >
          <div className="balance-logo flex-center-center">
            <img src={quickLink} />
          </div>
          <h2>Quick Links</h2>
        </Box>
        <Box className="flex-center-between" pt="10px" px="35px">
          <div className="links-icon cursor-pointer" onClick={handleOpen} >
            <div className="links-img">
              <img src={AddIcon} alt="" />
            </div>
            <p>Add</p>
          </div>
          <div className="links-icon">
            <div className="links-img">
              <img src={GoogleIcon} alt="" />
            </div>
            <p>Google</p>
          </div>
          <div className="links-icon">
            <div className="links-img">
              <img src={JiraIcon} alt="" />
            </div>
            <p>Jira</p>
          </div>
        </Box>
        <Modal modalOpen={open} setOpen={setOpen}/>
      </Box>
    </>
  );
};

export default QuickLinks;
